export const InterviewPropertySelectList = [
  { label: 'Language', value: 'language' },
  { label: 'Qualified', value: 'qualified' },
];

export enum EInterviewProperty {
  Language = 'language',
  Qualified = 'qualified',
}
